import React from "react";
import { Box, Typography } from "@mui/material";

const anchoVentana = window.innerWidth;
const altoVentana = window.innerHeight;

console.log("Ancho de la ventana:", anchoVentana);
console.log("Alto de la ventana:", altoVentana);

const Card = ({ title, text, icon, color }) => {
  return (
    <Box
      sx={{
        width: `${(window.innerWidth / window.innerHeight) * 90}vh`, // Ancho responsivo
        backgroundColor: color,
        boxShadow: "0 13px 19px rgba(0, 0, 0, 0.07)",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        paddingLeft: {
          xs: "2vh",
          sm: "3vh",
          md: "4vh",
          lg: "4vh",
          xl: "5vh",
        },
        paddingTop: { xs: "1.5vh", sm: "3vh" },
        paddingBlock: { xs: "1.5vh", sm: "3vh" },
        borderRadius: "20px",
      }}
    >
      <div>
        <Box sx={{ display: { xs: "none", sm: "block" } }}>
          <img
            src={icon}
            alt={title}
            style={{ width: "50px", height: "50px" }}
          />
        </Box>
        <Typography
          sx={{
            fontSize: {
              xs: "14px",
              sm: "22px",
              md: "24px",
              lg: "24px",
              xl: "26px",
            }, // Tamaño de fuente responsivo para título
            fontWeight: "bold",
            paddingTop: "1vh",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: {
              xs: "12px",
              sm: "16px",
              md: "16px",
              lg: "16px",
              xl: "18px",
            }, // Tamaño de fuente responsivo para texto
            marginTop: { xs: "0.5vh", sm: "1vh" },
            marginRight: "4vw",
            textAling: "justify",
            marginBottom: { xs: "0.5vh", sm: "1vh" },
          }}
        >
          {text}
        </Typography>
      </div>
    </Box>
  );
};

export default Card;
